import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from './button';
import { ArrowLeft, Home } from 'lucide-react';

/**
 * Componente reutilizable de botón para volver atrás
 * Si hay historial de navegación, vuelve atrás
 * Si no, va al dashboard
 */
const BackButton = ({ 
  className = '', 
  variant = 'ghost',
  showText = true,
  text = 'Volver',
  fallbackPath = '/app/dashboard',
  size = 'default'
}) => {
  const navigate = useNavigate();

  const handleBack = () => {
    // Verificar si hay historial de navegación
    if (window.history.length > 2) {
      navigate(-1);
    } else {
      navigate(fallbackPath);
    }
  };

  return (
    <Button 
      variant={variant} 
      size={size}
      onClick={handleBack}
      className={`gap-2 ${className}`}
      data-testid="back-button"
    >
      <ArrowLeft className="w-4 h-4" />
      {showText && <span>{text}</span>}
    </Button>
  );
};

/**
 * Versión compacta solo con icono
 */
export const BackButtonIcon = ({ className = '', fallbackPath = '/app/dashboard' }) => {
  return (
    <BackButton 
      className={className}
      showText={false}
      fallbackPath={fallbackPath}
      size="icon"
    />
  );
};

/**
 * Botón para ir directo al Dashboard
 */
export const DashboardButton = ({ className = '', variant = 'outline', showText = true }) => {
  const navigate = useNavigate();

  return (
    <Button 
      variant={variant}
      onClick={() => navigate('/app/dashboard')}
      className={`gap-2 ${className}`}
      data-testid="dashboard-button"
    >
      <Home className="w-4 h-4" />
      {showText && <span>Dashboard</span>}
    </Button>
  );
};

export default BackButton;
